// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__58k5P","underlined":"Link_underlined__AhZOE"};